var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-icon',{staticClass:"rounded-circle play-icon pa-1",staticStyle:{"border":"1px solid"}},[_vm._v("\n  mdi-play\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }